import { useMemo } from "react";
import moment from "moment";
import { prolongDate } from "../../../../../helpers/data-constants";
import createProlongCalculator from "./ProlongCalculators";

export const useProlongCalculations = (config) => {
  const createCalculator = createProlongCalculator(config);

  const prolongCalculator = useMemo(() => {
    return config.paramReq.map((deal) => {
      const calculator = createCalculator(deal);
      const isNewGlobalProlong = moment(deal?.startDate).isAfter(
        config.isExtensionThreeImplementaition
          ? prolongDate.crediton.NEW_PROLONG_DATE
          : prolongDate.visem.NEW_PROLONG_DATE
      );

      return {
        calculateDateDefault: calculator.calculateDateDefault,
        baseExtensionDateDefault: calculator.baseExtensionDate,
        isNewGlobalProlong,
      };
    });
  }, [config.paramReq]);

  return {
    prolongCalculator,
    isNewGlobalProlong: (index) => prolongCalculator[index]?.isNewGlobalProlong,
  };
};
